import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { CustomTooltip } from '../utils/chartUtils';

const RespiratoryChart = ({ chartData, timeRangeType }) => {
  const xAxisProps = {
    dataKey: "displayTime",
    angle: 0,
    textAnchor: timeRangeType === 'today' ? "end" : "end",
    height: 80,
    interval: "preserveStartEnd",
    tick: { fontSize: timeRangeType === 'today' ? 12 : 11 }
  };

  return (
    <ResponsiveContainer width="100%" height={350}>
      <AreaChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis {...xAxisProps} />
        <YAxis label={{ value: 'BPM', angle: -90, position: 'insideLeft' }} />
        <Tooltip content={<CustomTooltip />} />
        <Legend />
        <Area
          type="monotone"
          dataKey="respiratory_rate"
          stroke="#17a2b8"
          fill="#17a2b8"
          fillOpacity={0.3}
          strokeWidth={2}
          dot={{ r: timeRangeType === 'today' ? 4 : 3 }}
          activeDot={{ r: 8 }}
          name="Respiratory Rate"
          connectNulls={true}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default RespiratoryChart;